/* eslint-disable @nx/enforce-module-boundaries */
import { Box, Card, Divider, HStack, Scrollable, Stack } from '@mybridge/ui';
import { MyProfileActivity } from 'v4/components/profile/activity';
import { MyProfileCauses } from 'v4/components/profile/causes';

import { MyProfileEditButtonsGroup } from 'v4/components/profile/edit-btn-group';
import { MyProfileInterests } from 'v4/components/profile/interests';
import { MyProfileIntroduction } from 'v4/components/profile/introduction';
import { MyProfilePersonalInfo } from 'v4/components/profile/personal-info';
import { MyProfileLink } from 'v4/components/profile/profile-link';
import { MyProfileViewsCount } from 'v4/components/profile/views-count';
import { MyProfileVisibility } from 'v4/components/profile/visibility';
import { MyProfileAnalytics } from '../analytics';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { MyProfileContext } from 'v4/components/profile/context';
import { MyProfileAbout } from 'v4/snippets/profile/about';
import { MyConnectionsBox } from 'v4/components/profile/my-connections';

export const MyProfile = () => {
  const { userProfileInfo } = useContext(MyProfileContext);
  const { profile_intro: intro, profile_headline: headline } =
    userProfileInfo ?? {};

  return (
    <>
      {/*  */}
      <Stack direction={['column', 'row']} spacing={4} alignItems="flex-start">
        {!isMobile ? (
          <>
            <Stack w={['100%', '100%', '100%']} spacing={6}>
              {/* <Card p={4}>
            <MyProfileIntroduction />
          </Card> */}
              <MyProfileActivity />
            </Stack>
          </>
        ) : (
          <Stack w={isMobile ? '100%' : '20%'} maxW="100%" px={[0,3]}>
            {/* {intro?.length && (
              <Card p={3} variant="thinBorderedCard">
                <MyProfileIntroduction displayCard />
              </Card>
            )} */}

            {/* <MyProfileEditButtonsGroup /> */}
            {/* <Card p={3} variant="thinBorderedCard">
              <MyProfileViewsCount />
            </Card>
            <Card p={3} variant="thinBorderedCard">
              <MyProfileLink />
            </Card>
            <Card p={3} variant="thinBorderedCard">
              <MyProfileVisibility />
            </Card>
            <Card p={3} variant="thinBorderedCard">
              <MyProfileAnalytics />
            </Card>
            <Box py={3}>
              <MyConnectionsBox limit={2} />
            </Box>*/}
            <Box py={0}>
              <MyProfileActivity />
            </Box> 
            {/* <Box py={0}>
              <MyProfileAbout />
            </Box>
            <Box py={0}>
              <MyProfileActivity />
            </Box> */}
          </Stack>
        )}
      </Stack>
    </>
  );
};
